import { useState } from "react";
import Layout from "../components/Layout";
import { API, useAuth } from "../App";
import axios from "axios";
import { Building2, Save, User, Mail } from "lucide-react";
import { toast } from "sonner";

const Profil = () => {
  const { user, checkAuth } = useAuth();
  const [companyName, setCompanyName] = useState(user?.company_name || "OTO YEDEK PARÇA");
  const [saving, setSaving] = useState(false);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await axios.put(`${API}/profil`, {
        company_name: companyName
      }, { withCredentials: true });
      
      toast.success("Profil güncellendi");
      await checkAuth(); // Refresh user data
    } catch (error) {
      toast.error("Güncelleme başarısız");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      <div className="p-6 lg:p-8" data-testid="profil-page">
        {/* Header */}
        <div className="mb-8">
          <h1 className="font-heading text-2xl font-bold text-[#0A0A0B] tracking-tight">
            Şirket Profili
          </h1>
          <p className="text-[#5E5E62] text-sm mt-1">
            Şirket ve hesap bilgilerinizi yönetin
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left - User Info */}
          <div className="lg:col-span-1">
            <div className="bg-white border border-[#E4E4E7] rounded-sm p-6">
              <div className="flex flex-col items-center text-center">
                {user?.picture ? (
                  <img
                    src={user.picture}
                    alt={user.name}
                    className="w-20 h-20 rounded-full mb-4"
                  />
                ) : (
                  <div className="w-20 h-20 bg-[#002FA7] rounded-full flex items-center justify-center text-white text-2xl font-bold mb-4">
                    {user?.name?.charAt(0) || "U"}
                  </div>
                )}
                <h3 className="font-heading font-semibold text-[#0A0A0B]">{user?.name}</h3>
                <p className="text-sm text-[#5E5E62] mt-1">{user?.email}</p>
                <div className="mt-4 pt-4 border-t border-[#E4E4E7] w-full">
                  <p className="text-xs uppercase tracking-[0.1em] text-[#5E5E62] font-semibold">Rol</p>
                  <p className="text-sm font-medium text-[#0A0A0B] mt-1">Yönetici</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Company Settings */}
          <div className="lg:col-span-2">
            <div className="bg-white border border-[#E4E4E7] rounded-sm">
              <div className="px-6 py-4 border-b border-[#E4E4E7]">
                <h3 className="font-heading font-semibold text-[#0A0A0B]">Şirket Bilgileri</h3>
              </div>
              <form onSubmit={handleSave} className="p-6 space-y-6">
                {/* Company Name */}
                <div>
                  <label className="block text-sm font-medium text-[#0A0A0B] mb-2">
                    <Building2 size={16} className="inline mr-2" />
                    Şirket Adı
                  </label>
                  <input
                    type="text"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="input-default"
                    placeholder="Şirket adı"
                    data-testid="company-name-input"
                  />
                </div>

                {/* Read-only fields */}
                <div>
                  <label className="block text-sm font-medium text-[#0A0A0B] mb-2">
                    <User size={16} className="inline mr-2" />
                    Hesap Sahibi
                  </label>
                  <input
                    type="text"
                    value={user?.name || ""}
                    readOnly
                    className="input-default bg-[#F7F7F8]"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#0A0A0B] mb-2">
                    <Mail size={16} className="inline mr-2" />
                    E-posta
                  </label>
                  <input
                    type="email"
                    value={user?.email || ""}
                    readOnly
                    className="input-default bg-[#F7F7F8]"
                  />
                </div>

                <div className="pt-4 border-t border-[#E4E4E7]">
                  <button
                    type="submit"
                    disabled={saving}
                    className="btn-primary flex items-center gap-2"
                    data-testid="save-profile-btn"
                  >
                    <Save size={18} />
                    {saving ? "Kaydediliyor..." : "Değişiklikleri Kaydet"}
                  </button>
                </div>
              </form>
            </div>

            {/* System Info */}
            <div className="bg-white border border-[#E4E4E7] rounded-sm mt-6">
              <div className="px-6 py-4 border-b border-[#E4E4E7]">
                <h3 className="font-heading font-semibold text-[#0A0A0B]">Sistem Bilgileri</h3>
              </div>
              <div className="p-6">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <p className="text-[#5E5E62]">Uygulama</p>
                    <p className="font-medium text-[#0A0A0B]">FinansKontrol</p>
                  </div>
                  <div>
                    <p className="text-[#5E5E62]">Versiyon</p>
                    <p className="font-medium text-[#0A0A0B]">1.0.0</p>
                  </div>
                  <div>
                    <p className="text-[#5E5E62]">Kullanıcı ID</p>
                    <p className="font-mono text-xs text-[#5E5E62]">{user?.user_id}</p>
                  </div>
                  <div>
                    <p className="text-[#5E5E62]">Kimlik Doğrulama</p>
                    <p className="font-medium text-[#0A0A0B]">Google OAuth</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profil;
